import { api } from '@/fsd/shared/api';
import {
  GetNotificationsListResponse,
  NotificationStatus,
} from '../../model/types/types';

interface GetNotificationsCountResponse {
  message: string;
  data: {
    total: number;
    new: number;
    has_notifications: boolean;
  };
}

export const getNotificationsCount = async (): Promise<
  GetNotificationsCountResponse | undefined
> => {
  const data = await api.get<GetNotificationsCountResponse>(
    '/api/v1/notification/count/'
  );
  return data;
};
